import { FC } from "react";
import Modal from "react-bootstrap/Modal";
import SubmitButton from "../Button";

interface StateProps {
  title?: string;
  show: boolean;
  message: string;
  onConfirm: (data: any) => void;
  handleClose: () => void;
  confirmText?: string;
  cancelText?: string;
  centered?: boolean;
  cancelClassName?: string;
  confirmClassName?: string;
  titleClass?:string;
}
const ConfirmBox: FC<StateProps> = ({
  title = "Confirm",
  show,
  message,
  onConfirm,
  handleClose,
  confirmText = "Yes",
  cancelText = "Close",
  centered = false,
  cancelClassName,
  confirmClassName,
  titleClass = ""
}) => {

  return (
    <Modal show={show} onHide={handleClose} centered={centered}>
      <Modal.Header closeButton>
        <Modal.Title className={titleClass}>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{message}</Modal.Body>
      <Modal.Footer>
        <SubmitButton type="secondary" onClick={handleClose} className={cancelClassName}>
          {cancelText}
        </SubmitButton>
        <SubmitButton type="primary" onClick={onConfirm} className={confirmClassName}>
          {confirmText}
        </SubmitButton>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmBox;
